// Copyright (C) 2020 TANNER AG

import React, { useState } from "react";
import { compose, withProps } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Navigation from "../layouts/Navigation";
import Heading2 from "../styleguide/Heading2";
import withPodcasts from "../hocs/withPodcasts";
import PodcastsItem from "../components/PodcastsItem";
import { contains, uniq } from "ramda";
import PodcastsKeyword from "../components/PodcastsKeyword";
import PodcastsTypeFilter from "../components/PodcastsTypeFilter";

const styles = (theme) => ({
    containerStyle: {
        flex: "1 0 auto",
        padding: "0 36px 100px 36px",
        background: "#fafafa",
    },
    gridStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
    },
    contentContainerStyle: {
        marginTop: 70,
        marginLeft: "auto",
        marginRight: "auto",
    },
    headingStyle: {
        marginBottom: 20,
    },
    toolbar: {
        marginBottom: 16,
        display: "flex",
    },
    keywords: {
        display: "flex",
        alignItems: "center",
    },
    typeKeywords: {
        marginLeft: "auto",
    },
});

const Podcasts = (props) => {
    const [selectedKeywords, setSelectedKeywords] = useState([]);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const { classes, podcasts } = props;
    let keywords = [];
    let typeKeywords = [];

    podcasts.forEach((podcast) => {
        if (podcast.keywords) {
            keywords = uniq([...keywords, ...podcast.keywords.split("|")]);
            typeKeywords.push(podcast.mediaType);
        }
    });

    typeKeywords = uniq(typeKeywords);

    const handleKeywordClick = (keyword) => {
        const currentKeywords = [...selectedKeywords];
        const currentIndex = currentKeywords.indexOf(keyword);

        if (currentIndex === -1) {
            currentKeywords.push(keyword);
        } else {
            currentKeywords.splice(currentIndex, 1);
        }

        setSelectedKeywords(currentKeywords);
    };

    const handleKeywordTypeClick = (keyword) => {
        const currentKeywords = [...selectedTypes];
        const currentIndex = currentKeywords.indexOf(keyword);

        if (currentIndex === -1) {
            currentKeywords.push(keyword);
        } else {
            currentKeywords.splice(currentIndex, 1);
        }

        setSelectedTypes(currentKeywords);
    };

    let filteredPodcasts = podcasts.filter((podcast) => {
        return (
            !Boolean(selectedKeywords.length) ||
            (podcast.keywords && podcast.keywords.split("|").some((keyword) => contains(keyword, selectedKeywords)))
        );
    });

    filteredPodcasts = filteredPodcasts.filter(
        (podcast) => !Boolean(selectedTypes.length) || selectedTypes.includes(podcast.mediaType)
    );

    return (
        <div className={classes.containerStyle}>
            <Grid container spacing={0} className={classes.gridStyle}>
                <Navigation enableOverviewShortcuts={false} />
                <Grid item xs={8} className={classes.contentContainerStyle}>
                    <Heading2 className={classes.headingStyle}>BusCasts</Heading2>
                    <div>
                        <div className={classes.toolbar}>
                            <div className={classes.keywords}>
                                {keywords.map((keyword) => (
                                    <PodcastsKeyword
                                        key={keyword}
                                        label={keyword}
                                        onClick={() => handleKeywordClick(keyword)}
                                        selected={contains(keyword, selectedKeywords)}
                                    />
                                ))}
                            </div>
                            <div className={classes.typeKeywords}>
                                <div>
                                    <PodcastsTypeFilter selected={selectedTypes} onClick={handleKeywordTypeClick} />
                                </div>
                            </div>
                        </div>
                        {filteredPodcasts.map((podcast) => (
                            <PodcastsItem
                                key={podcast.id}
                                title={podcast.title}
                                description={podcast.shortdescription}
                                date={podcast.publicationDate}
                                teaserImage={podcast.teaserImage}
                                linkUrl={`/buscast/${podcast.id}`}
                                type={podcast.mediaType || ""}
                            />
                        ))}
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default compose(
    withProps(({ match: { params } }) => {
        const currentNewsPage = params.page ? parseInt(params.page, 10) : 0;

        return {
            newsSize: 10,
            newsSkip: 0,
            currentNewsPage,
        };
    }),
    withPodcasts(),
    withStyles(styles)
)(Podcasts);



// WEBPACK FOOTER //
// ./src/screens/Podcasts.js